const TRAILING_EMPTY_BLOCK_PATTERN =
  /(?:<(p|div|h[1-6]|blockquote|li)>\s*(?:<br\s*\/?>|&nbsp;|\u200B|\s)*<\/\1>\s*)+$/giu;

const EMBED_SELECTOR = 'img,video,iframe,embed,object,table,pre,code';

const getNormalizedTextLength = (html: string) =>
  html.replace(/<[^>]+>/g, '').replace(/\u00a0|\u200B|\s/gu, '').length;

const isEmptyTrailingBlock = (element: Element) => {
  if (element.querySelector(EMBED_SELECTOR)) {
    return false;
  }

  const textContent = element.textContent
    ?.replace(/\u00a0|\u200B/gu, '')
    .trim();
  const htmlContent = element.innerHTML
    .replace(/<br\s*\/?>/giu, '')
    .replace(/&nbsp;/giu, '')
    .replace(/\u200B/gu, '')
    .trim();

  return !textContent && !htmlContent;
};

export const trimTrailingEmptyQuillBlocks = (html: string) => {
  const trimmedHtml = html.trim();

  if (!trimmedHtml) {
    return '<p></p>';
  }

  // Only trim trailing empty blocks when the editor content has
  // at least one real text character. Whitespace-only content should
  // normalize to an explicit empty paragraph so the caller can still save it.
  if (getNormalizedTextLength(trimmedHtml) < 1) {
    return '<p></p>';
  }

  if (typeof document === 'undefined') {
    return trimmedHtml.replace(TRAILING_EMPTY_BLOCK_PATTERN, '').trim();
  }

  const container = document.createElement('div');
  container.innerHTML = trimmedHtml;

  while (
    container.lastElementChild &&
    isEmptyTrailingBlock(container.lastElementChild)
  ) {
    container.lastElementChild.remove();
  }

  const normalizedHtml = container.innerHTML.trim();

  if (getNormalizedTextLength(normalizedHtml) < 1) {
    return '<p></p>';
  }

  return normalizedHtml;
};
